import { create } from 'zustand'

export interface GlobalThemeState {
  theme: {
    colorPrimary: string,
    logoUrl?: string,
    loginPageImageUrl?: string,
    systemName?: string,
    loginPageBgcolor?: string,
  }
  setTheme: (theme: GlobalThemeState['theme']) => void
}

const useGlobalThemeStore = create<GlobalThemeState>((set) => ({
  theme: {
    colorPrimary: '',
    logoUrl: '',
    loginPageImageUrl: '',
    systemName: '',
    loginPageBgcolor: '',
  },
  setTheme: (theme: GlobalThemeState['theme']) => {
    set((prevState) => ({
      theme: {
        ...prevState.theme,
        ...theme,
      },
    }))
  }
}))

export default useGlobalThemeStore